import { useEffect, useState } from 'react';
import { useAppContext } from '../Store';
import { SET_PREVIOUS_VIEWDOC_ID } from '../reducer';

function useHighlightCard(
  headerRef: React.MutableRefObject<HTMLDivElement | null>,
  docId: string | undefined,
  disableCardAnchor: boolean
) {
  const [highlightCard, setHighlightCard] = useState(false);
  const [highlightHeader, setHighlightHeader] = useState(false);
  const { state, dispatch } = useAppContext();

  const FROM_EDIT_TAG = 'from-edit';

  useEffect(() => {
    if (!state.previousViewDocId) return;

    const idAndType = state.previousViewDocId?.split('|');

    if (disableCardAnchor) {
      dispatch({ type: SET_PREVIOUS_VIEWDOC_ID, payload: '' });
      setHighlightCard(false);
      setHighlightHeader(false);
    } else if (idAndType[0] === docId && headerRef.current) {
      const y = headerRef?.current.getBoundingClientRect().top + window.scrollY - 58;
      window.scrollTo({ top: y, behavior: 'smooth' });
      if (idAndType.length > 1 && idAndType[1] === FROM_EDIT_TAG) {
        setHighlightHeader(true);
      } else {
        setHighlightCard(true);
      }
    } else {
      setHighlightCard(false);
      setHighlightHeader(false);
    }
  }, [state.previousViewDocId, disableCardAnchor, dispatch, headerRef, docId]);

  //reset inner hit border on collapse
  useEffect(() => {
    return () => {
      if (state.previousViewDocId === docId) {
        dispatch({ type: SET_PREVIOUS_VIEWDOC_ID, payload: '' });
      }
    };
  }, [state.previousViewDocId, docId, dispatch]);

  return { highlightCard, highlightHeader };
}

export default useHighlightCard;
